<template>
  <div
    v-show="modalVisible"
    class="sf-modal sf-modal-top sf-modal-s"
    @click="toggleModal"
    @keyup.esc="toggleModal"
  >
    <div class="sf-modal-backdrop"></div>
    <div v-if="modalVisible" class="sf-modal-container">
      <search-form
        :limit="limit"
        :should-focus-after-mount="true"
      ></search-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import SearchForm from './search-form'

export default {
  name: 'SearchModal',
  components: {
    'search-form': SearchForm,
  },

  props: {
    limit: {
      type: Number,
      default: 4,
    },
  },

  computed: {
    ...mapGetters(['modalVisible']),
  },

  methods: {
    ...mapActions(['toggleModal']),
  },
}
</script>
